var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "go-modal",
    {
      attrs: { "dialog-class": "go-modal-connect", "hide-footer": true },
      on: { "modal:close": _vm.close },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c("div", { staticClass: "modal-title" }, [_vm._v("Account")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "go-form-connect-account" },
        [
          _c("div", { staticClass: "go-form-header" }, [
            _c("div", { staticClass: "go-brand" }, [
              _c("div", { staticClass: "go-brand-symbol" }, [
                _c("img", {
                  attrs: { src: _vm.channelImageUri, alt: _vm.channelName },
                }),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.channelName))]),
            ]),
          ]),
          _vm._v(" "),
          _vm.loading
            ? _c("go-loading")
            : _c("div", { staticClass: "go-form-body" }, [
                _c(
                  "div",
                  { staticClass: "account-select" },
                  [
                    _vm._l(_vm.accounts, function (acc, index) {
                      return [
                        _c(
                          "a",
                          {
                            key: index,
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.ok(acc)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "go-user-thumb" }, [
                              _c("img", {
                                attrs: {
                                  src: acc.avatar,
                                  alt: acc.accountName,
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(acc.accountName))]),
                          ]
                        ),
                      ]
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.register(_vm.channelType)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "go-icon-16 go-icon-plus" }),
                        _vm._v(
                          "\n          Register another account\n        "
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }